import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Hero } from './hero';
import { Features } from './features';
import { FeatureButtom } from './feature_buttom';
import { TradingCapabilities } from './trading-capabilities';
import './styles.scss';

const Home: React.FC = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`home ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <Hero />
      <TradingCapabilities />
      <Features />
      <FeatureButtom />
    </div>
  );
};

export default Home;